export default __webpack_public_path__ + "media/splashpage/bg-full-right-e8518592.svg";